// Решение жеста «потянуть-обновить» без React (HQ-1684). Офлайн TanStack Query (networkMode 'online') ставит
// refetch на паузу — промис не завершается, и `busy` висел бы до возврата сети. Поэтому офлайн — только тост
// mc_offline (при видимой плашке «нет сети» Toast сам его гасит, HQ-1659 v2), онлайн — refetch наперегонки
// с таймаутом, `busy` снимается в любом случае.
export const REFRESH_TIMEOUT_MS = 10_000;

export interface PullRefreshDeps {
  isOnline: () => boolean;
  refetch: () => Promise<unknown>;
  toast: (text: string) => void;
  offlineText: () => string;
  setBusy: (busy: boolean) => void;
  timeoutMs?: number;
}

/** Выполнить обновление по жесту; промис завершается всегда — по ответу, по ошибке или по таймауту. */
export async function runPullRefresh(deps: PullRefreshDeps): Promise<void> {
  if (!deps.isOnline()) { deps.toast(deps.offlineText()); return; }
  deps.setBusy(true);
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<void>((resolve) => { timer = setTimeout(resolve, deps.timeoutMs ?? REFRESH_TIMEOUT_MS); });
  try {
    await Promise.race([deps.refetch().then(() => undefined, () => undefined), timeout]);
  } finally {
    clearTimeout(timer);
    deps.setBusy(false);
  }
}
